module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAASCAYAAABSO15qAAABXUlEQVQ4jZXTO0iWYRQH8N9rHwThILRESzgEujkIQkmEW+gkGKEgDtLFoaArglNDiWBrgkJDn6NXEAWJaBACh6ZaoihawhKJniGK1OE7Hzw46OuznOf8Oed/7kVKyTHeGO6hgpcYqRzDeQ69WMEP3EJnUTKDLrzCKMYDO4OPDSWjnws5nmHfMVuW4HTI+xnWjP68hJ5IdR2rgbVgBhczxwVs4QZ+FSmlCl6jMzOaw2c8CP0xZjGCO4GtYLhIKU0F21BEb8dSGM3jIT5l5KdwEjtQpJT2sIYrmdEz3Fab96Gv3sTfB/A9/D3KuU6wiD5cCr0Nd/GlLMEgvuIN/uMd/qEVP9Gd2V/Hn8iwisb6GBvUtuwCNvAcVzEVjlV8wJOQW7iMb0etchOe4mboE3gU/w5slL2F0YheHMCny67ycsihDDuL3rLn/B5v8QLnsY1J7JYtAU6oNfNa6JsY2AdLOGEIBQzqCQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-shenbao.png
// module id = hMvu
// module chunks = 22